import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ASSETS, LORE_CHAPTERS } from "@/data/content";
import PageHero from "@/components/arc/PageHero";
import Reveal from "@/components/arc/Reveal";
import { GlowButton } from "@/components/arc/ui";
import { GlowOrbs } from "@/components/arc/Backdrops";

const Chapter = ({ chapter, index }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const even = index % 2 === 0;

  return (
    <div
      ref={ref}
      data-testid={`lore-chapter-${chapter.id}`}
      className="relative grid items-center gap-10 border-t border-ice/10 py-20 md:py-28 lg:grid-cols-2"
    >
      <div className={even ? "" : "lg:order-2"}>
        <Reveal>
          <p className="font-term text-[11px] tracking-[0.4em] text-electric">
            CHAPTER {chapter.id}
          </p>
          <h2 className="mt-4 font-display text-3xl font-black tracking-[0.08em] text-chrome text-glow-blue sm:text-4xl lg:text-6xl">
            {chapter.title}
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-silver md:text-lg">
            {chapter.body}
          </p>
        </Reveal>
      </div>
      <Reveal delay={0.1} className={even ? "" : "lg:order-1"}>
        <div className="clip-angular relative h-64 overflow-hidden border border-ice/15 md:h-96">
          <motion.img
            src={index % 2 === 0 ? ASSETS.background : ASSETS.banner}
            alt={`${chapter.title} — cinematic Arc universe artwork`}
            style={{ y }}
            className="h-[116%] w-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-abyss/70 via-transparent to-abyss/30" />
          <span className="absolute bottom-4 left-4 font-term text-[10px] tracking-[0.3em] text-ice/80">
            PRIME RECORD {"//"} {chapter.id}
          </span>
        </div>
      </Reveal>
    </div>
  );
};

const Lore = () => (
  <>
    <PageHero
      index="02"
      eyebrow="LORE"
      title="THE RISE OF ARCIMUS"
      sub="Five chapters. One machine. The story of how a tool became a participant."
    />
    <section className="relative overflow-hidden pb-20 md:pb-28">
      <GlowOrbs />
      <div className="relative mx-auto max-w-[1600px] px-5 md:px-8">
        {LORE_CHAPTERS.map((chapter, i) => (
          <Chapter key={chapter.id} chapter={chapter} index={i} />
        ))}
        <Reveal>
          <div className="flex flex-col items-center gap-6 border-t border-ice/10 pt-16 text-center">
            <p className="max-w-xl font-display text-xl font-bold tracking-[0.12em] text-ice md:text-2xl">
              THE RECORD CONTINUES IN THE TERMINAL.
            </p>
            <GlowButton to="/terminal" testId="lore-terminal-btn">OPEN THE TERMINAL</GlowButton>
          </div>
        </Reveal>
      </div>
    </section>
  </>
);

export default Lore;
